<template>
    <div>
        <b-row>
            <b-col md="12">
                    <b-card>
                        <b-row>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('course_code')">
                                    {{ formData.code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('course_name')">
                                    {{ getLocaleText(formData, 'name') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('course_language')">
                                    {{ formData.language }}
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
        </b-row>
        <b-row>
            <b-col md="12" class="mt-2">
                <b-card :header="$t('course_outcomes_semesters').toUpper()" header-tag="header">
                    <ValidationObserver ref="formValidate">
                        <b-row>
                            <b-col sm="12" md="6">
                                <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                                    <b-form-group :label="$t('semester')">
                                        <semesters-selectbox
                                            @input="getData"
                                            v-model="newFormData.semester_id"
                                            :validate-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md="12">
                                <b-row v-show="newFormData.semester_id">
                                    <b-col sm="12" md="12" class="mb-2" v-for="outcome in outcomes" :key="outcome.id">
                                        <b-form-checkbox :id="'checkbox'+outcome.id"
                                                         v-model="outcome.checked"
                                                         @change="update(outcome)"
                                                         :value="outcome.id">
                                            <span>{{ getLocaleText(outcome, 'name') }}</span>
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </ValidationObserver>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-show="1 == 2">
            <b-col md="12" class="mt-2">
                <b-card>
                    <b-row>
                        <b-col md="12" v-if="checkPermission('courseoutcomesemester_store')">
                            <b-button variant="primary" @click="newCourseOutcome">{{ $t('new') }}</b-button>
                        </b-col>
                        <b-col md="12">
                            <b-table
                                :empty-filtered-text="$t('no_result')"
                                :empty-text="$t('no_result')"
                                bordered
                                striped
                                responsive
                                :items="tableData"
                                :fields="tableFields"
                                show-empty
                                class="mb-5 mt-2 table-dropdown no-scrollbar border rounded">
                                <template #cell(buttons)="row">
                                    <b-dropdown variant="link btn-sm" boundary="window" no-caret>
                                        <template #button-content>
                                            <i class="ri-more-fill"></i>
                                        </template>
                                        <div id="dropdownListHead">
                                            <b-dropdown-item v-if="checkPermission('courseoutcomesemester_update')" @click="openUpdateCourseOutcomes(row.item)">
                                                <i class="ri-edit-box-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('edit')}}
                                            </b-dropdown-item>
                                            <b-dropdown-item v-if="checkPermission('courseoutcomesemester_delete')" @click="deleteCourseOutcomes(row.item)">
                                                <i class="ri-delete-bin-2-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('delete')}}
                                            </b-dropdown-item>
                                        </div>
                                    </b-dropdown>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// Components

// Services
import EctsService from "@/services/EctsService"

// Other
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {checkPermission} from "@/main";
import qs from "qs";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    props: {
        course: {
            type: Object,
        },
        forceRefresh: {
            type: Boolean,
        }
    },
    data() {
        return {
            formLoading: false,
            formData: {},
            tableData: [],
            tableFields: [
                {
                    key: 'buttons',
                    label: ''
                },
                {
                    key: this.getLocaleField('course_outcome_name'),
                    label: this.$t('ects_course_outcome')
                },
                {
                    key: this.getLocaleField('semester_name'),
                    label: this.$t('semester')
                }
            ],
            newFormData: {},
            outcomes: null
        };
    },
    watch: {
        forceRefresh: {
            handler(value) {
                if (value === true) {
                    this.getData()
                }
            }
        }
    },
    created() {
        this.formData = this.course
        this.getCourseOutcomes()
    },
    methods: {
        getCourseOutcomes(){
            EctsService.getProgramCoordinatorCourseOutcomes(this.course.id).then(response => {
                this.outcomes = response.data.data
            }).catch(e => {
                this.showErrors(e)
            })
        },

        getData(selected){
            const config = {
                params: {
                    filter: {
                        course_id: this.course.id,
                        semester_id: selected
                    }

                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            }
            EctsService.getCourseOutcomesSemesters(config).then(response => {
                this.outcomes.forEach((item, index) => {
                    delete this.outcomes[index].checked
                    response.data.data.forEach(item2 => {
                        if(item2.course_outcome_id == item.id){
                            this.outcomes[index].checked = item.id
                            this.outcomes[index].course_outcome_semester_id = item2.id
                        }
                    })
                })
                this.tableData = response.data.data
            }).catch(e => {
                this.showErrors(e)
            })
        },

        update(data){
            if(checkPermission('courseoutcomesemester_store') && checkPermission('courseoutcomesemester_delete')){
                if(data.id == data.checked){
                    let formData = {
                        semester_id: this.newFormData.semester_id,
                        course_outcome_id: data.id
                    }
                    EctsService.storeCourseOutcomeSemesters(formData).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                    }).catch(e => {
                        this.showErrors(e, this.$refs.formValidate)
                    })
                } else {
                    EctsService.deleteCourseOutcomeSemesters(data.course_outcome_semester_id).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                    }).catch(e => {
                        this.showErrors(e)
                    })
                }
            } else {
                this.$toast.error(this.$t('unauthorized_operation'));
            }
        },

        newCourseOutcome() {
            this.course.actionType = "new"
            this.$emit('openComponent',this.course, 'course-outcomes-semesters-form')
        },

        openUpdateCourseOutcomes(data){
            this.course.actionType = "update"
            data.code = this.course.code
            data.course_name = this.course.name
            data.language = this.course.language
            data.course_id = this.course.id
            this.$emit('openComponent', data, 'course-outcomes-semesters-form')
        },

        deleteCourseOutcomes(data){
            this.$swal.fire({
                    title: this.$t('attention'),
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                }).then((result) => {
                if (result.isConfirmed) {
                    EctsService.deleteCourseOutcomeSemesters(data.id).then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.getData()
                    }).catch(e => {
                        this.showErrors(e)
                    })
                }
            })
        }

    },
}
</script>
